import React, { FC } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import colors from '~/constants/colors';
import { GlobeIcon } from '~/img';
import { useDirection } from '~/hooks/i18nHooks';
import { useSetLanguage } from '~/hooks/i18nHooks';
import { useCommonErrors } from '~/controllers/validation';

import './styles.less';

const LanguageSelector: FC = () => {
  const dir = useDirection();
  const { t } = useTranslation('fillApplication');
  const { language, setLanguage } = useSetLanguage();
  const [, { clearError }] = useCommonErrors();

  const handleToggle = () => {
    const nextLang = language === 'en' ? 'ar' : 'en';
    setLanguage(nextLang);
    clearError();
  };

  return (
    <StyledButton
      className="LanguageSelector"
      shape="round"
      size="middle"
      dir={dir}
      onClick={handleToggle}
    >
      {dir === 'rtl' && t('English')}
      <GlobeIcon className="LanguageSelector-GlobeIcon" />
      {dir === 'ltr' && 'العربية'}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  border-width: 0;
  border-color: ${colors.borderColorBase};
  background: transparent;
  box-shadow: none;
  padding: 9px;

  //margin: -9px;
  color: ${colors.textColor};
  height: 42px;
  &:hover,
  &:focus,
  &:active {
    border-color: ${colors.borderColorBase};
    box-shadow: 0px 0px 0.5px 0.5px ${colors.borderColorBase};
    color: ${colors.textColor};
    background-color: transparent;
  }

  .anticon {
    display: flex;
  }
  .LanguageSelector-GlobeIcon {  
    font-size: 32px;
  }
  .LanguageSelector-ArrowDownIcon {
    font-size: 12px;
  }

  &[dir='rtl'] {
    .LanguageSelector-ArrowDownIcon {
      margin-left: 0 !important;
      margin-right: 8px;
    }
  }
`;

export default LanguageSelector;
